import React from 'react';
// import { getOSVersionInfo } from '../../helper/common-helper.js';

function protocolIsHttps() {
  return location.protocol === 'https:';
}

function getImageHttpsProtocolUrl(src) {
  if (!src) {
    return src;
  }
  const prevOldCdn = 'http://kry-official.qiniudn.com'; // 最老的cdn
  const oldCdn = 'https://img.keruyun.net'; // 七牛cdn
  const newCdn = 'https://img-static.keruyun.com'; // 阿里cdn
  let url = src;

  if (/^http:\/\/img\.keruyun\.(net|com)/i.test(url)) {
    url = url.replace('http://', 'https://');
  }

  if (url.indexOf(prevOldCdn) === 0) {
    url = url.replace(prevOldCdn, newCdn);
  }

  if (url.indexOf(oldCdn) === 0) {
    url = url.replace(oldCdn, newCdn);
  }

  return url;
}

class HttpsProtocolImage extends React.Component {
  static propTypes = {
    src: React.PropTypes.string,
    alt: React.PropTypes.string,
    role: React.PropTypes.string,
    className: React.PropTypes.string,
    loadErrorImageSrc: React.PropTypes.string,
    style: React.PropTypes.object,
    bgImg: React.PropTypes.bool,
  };

  static getFinalImageUrl(url) {
    if (!protocolIsHttps()) {
      return url;
    }

    /*
    const osInfo = getOSVersionInfo();
    if (osInfo.os === 'iphone' && osInfo.version >= 10) {
      return getImageHttpsProtocolUrl(url);
    }

    return url;
    */
    return getImageHttpsProtocolUrl(url);
  }

  constructor(props) {
    super(props);
    this._loadedImages = [];
  }

  handleImageLoadError = (event) => {
    const { target } = event;
    const { loadErrorImageSrc } = this.props;

    if (this._loadedImages.indexOf(target.src) !== -1) {
      return;
    }

    this._loadedImages.push(target.src);
    if (loadErrorImageSrc) {
      target.src = loadErrorImageSrc;
    }
  }

  render() {
    const { src, alt, className, style, role, bgImg } = this.props;
    const finalUrl = HttpsProtocolImage.getFinalImageUrl(src);

    if (!finalUrl) {
      return (<span className={className} style={style} />);
    }

    if (bgImg) {
      return (
        <div
          className={className}
          alt={alt}
          onError={this.handleImageLoadError}
          role={role}
          style={Object.assign(style, { backgroundImage: `url(${finalUrl})` })}
        ></div>
      );
    }

    return (
      <img
        className={className}
        src={finalUrl}
        alt={alt}
        onError={this.handleImageLoadError}
        style={style}
        role={role}
      />
    );
  }
}

export default HttpsProtocolImage;



// WEBPACK FOOTER //
// ./src/component/common/https-protocol-image.jsx